import Work1 from "../../images/work1.jpg";
import Work2 from "../../images/work2.jpg";
import Work3 from "../../images/work3.jpg";
import Work4 from "../../images/work4.jpg";
import Work5 from "../../images/work5.jpg";
import Work6 from "../../images/work6.jpg";

export const WorkProjectData = [
  {
    id: 1,
    image: Work1,
    title: "E Commerce Website",
    category: "design",
    url: "https://advancedflowcontrols.com/",
  },
  {
    id: 2,
    image: Work2,
    title: "E Commerce Website",
    category: "design",
    url: "https://kamaltec.shop/"
  },
  {
    id: 3,
    image: Work3,
    title: "Car Purchasing",
    category: "product",
    url: "https://www.asawajapan.com/"
  },
  {
    id: 4,
    image: Work4,
    title: "Social Website",
    category: "product",
    url: "https://hoopxrecruit.com/"
  },
  {
    id: 5,
    image: Work5,
    title: "ALI YAQOOB",
    category: "E Commerce Website",
    url: "https://aliyaqoob.com/"
  },
  {
    id: 6,
    image: Work6,
    title: "Portfolio Website",
    category: "design",
    url: "https://mhammadk-portfolio.netlify.app/"
  },
];

export const WorkNavData = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "product",
  },
  {
    name: "design",
  },
];
